// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"qt6rwxWG","tabButtons":"Cgt_pm_n","tabButton":"WWQ5Fnus","current":"J8Ng0mQm","divider":"_68H6VKc"};